<template>
  <div v-for="klass in props.configData" :key="klass.technicalName" class="simulator-class-list-item-component">
    <header class="class-header">
      {{ klass.technicalName }}
    </header>
    <DataTable :value="klass.instances">
      <Column header="Attribute name" :header-class="$style.columnHeader">
        <template #body="attribute">
          <span>Instance {{ attribute.index + 1 }}</span>
        </template>
      </Column>
      <Column
        v-for="(attribute, index) in klass.attributes"
        :key="attribute"
        :header="attribute"
        :header-class="$style.columnHeader"
      >
        <template #body="rowProps">
          <div
            v-if="Array.isArray(JSON.parse(klass.instances[rowProps.index].values[index].value))"
            class="class-attribute-tags"
          >
            <span
              v-for="(item, itemIndex) in JSON.parse(klass.instances[rowProps.index].values[index].value) || []"
              :key="`tags-${itemIndex}`"
            >
              {{ item }}
            </span>
          </div>
          <div v-else>
            {{ klass.instances[rowProps.index].values[index].value }}
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
import { SimulationClass } from "@/modules/Simulation/types";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import { PropType } from "vue";

const props = defineProps({
  configData: {
    type: Array as PropType<SimulationClass[]>,
    required: true,
  },
});
</script>

<style module lang="scss">
.p-datatable-table {
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  border-width: 1px 1px 0 1px;

  .columnHeader {
    background: #f9fafb !important;
  }
}

.p-datatable-table > thead > tr:first-of-type > th:first-of-type {
  border-radius: 0.5rem 0 0 0;
}

/* Top Right Would be: */
.p-datatable-table > thead > tr:first-of-type > th:last-of-type {
  border-radius: 0 0.5rem 0 0;
}

/* Bottom Left Would Be: */
.p-datatable-table > tbody > tr:last-of-type > td:first-of-type {
  border-radius: 0 0 0 0.5rem;
}

/* Bottom Right Would Be: */
.p-datatable-table > tbody > tr:last-of-type > td:last-of-type {
  border-radius: 0 0 0.5rem 0;
}
</style>

<style lang="scss">
.simulator-class-list-item-component {
  margin-top: 1rem;

  .class-attribute-tags {
    @extend %tags;
    margin-top: 0.5rem;
    justify-content: flex-start;

    span {
      padding: 6px 8px;
    }
  }

  .p-datatable {
    color: var(--vd-color-text-default);
    border: 1px solid var(--vd-color-text-light-7);
    border-bottom: 1px;
    border-top: none;

    .p-datatable-thead > tr > th {
      background: var(--vd-color-text-light-9);
    }

    .p-datatable-tbody > tr > td:first-child {
      background: var(--vd-color-text-light-9) !important;
      border-right: 1px solid var(--vd-color-text-light-7);
      font-weight: 700;
      min-width: 150px;
      width: 150px;
    }
  }

  .p-datatable-thead {
    color: var(--vd-color-text-default);
    font-weight: 700;
  }

  header.class-header {
    display: flex;
    align-items: center;
    padding: 0.75rem;
    font-weight: 700;
    background-color: var(--vd-color-text-light-9);
    border: 1px solid var(--vd-color-text-light-7);
  }
}
</style>
